// extracted by mini-css-extract-plugin
module.exports = {"root":"root___3aHIb","withBorder":"withBorder___278b7","wide":"wide___33u0U","loading":"loading___3jurA"};